// ServiceFour component - Converted from components/ServiceFour.vue
// Services section variant with icons
// Converted: <template> -> JSX, v-for -> map, :src -> src, :class -> className, NuxtLink -> Link
import React from 'react';
import leafImg from '../assets/images/resources/leaf.png';

const ServiceFour = () => {
  // Converted from Vue: services array
  const services = [
    {
      icon: 'icon-temperature',
      title: 'Produits biologiques',
      description:
        'Nous offrons une variété de produits biologiques, cultivés avec soin et respectueux de l’environnement, pour une alimentation saine et durable.',
    },
    {
      icon: 'icon-harvest',
      title: 'Semences certifiées',
      description:
        'Nous mettons à votre disposition des semences certifiées de haute qualité, garantissant des récoltes abondantes et résistantes aux maladies.',
    },
    {
      icon: 'icon-growth',
      title: "Conseils d'experts",
      description:
        'Bénéficiez de nos conseils personnalisés pour optimiser vos pratiques agricoles, améliorer votre rendement et préserver la fertilité de vos sols.',
    },
  ];

  return (
    <section className="service_four" style={{ marginTop: '180px' }}>
      <div className="container">
        <div className="service_four_top"></div>
        <div className="block-title text-center">
          <p>Ce que nous faisons</p>
          <h3>Services que nous offrons</h3>
          <div className="leaf">
            <img src={leafImg} alt="Decorative leaf" />
          </div>
        </div>
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-xl-4 col-lg-4 d-flex">
              <div className="service_four_single h-100 d-flex flex-column">
                <div className="service_four_icon">
                  <span className={service.icon}></span>
                </div>
                <div className="service_four_deatils flex-grow-1">
                  <h3>
                    <span className="service_four_title">{service.title}</span>
                  </h3>
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFour;
